import { useState } from 'react';
import { useUnit } from 'effector-react';
import { $accountByIdStore } from '@lib/store';
import { cn, PaletteUtils } from '@shared/utils';
import { AccountSidebarItems } from './accountSidebarItems';
import { EditDetailsModal } from './modalEditDetails';
import { ChangeAlertModal } from './changeAlertModal';
import { EditRecipientsModal } from '@widgets';

export const AccountSidebar = () => {
  const accountDetailsStore = useUnit($accountByIdStore.store);
  const account = accountDetailsStore.data;

  const [showModalEdit, setShowModalEdit] = useState<boolean>(false);
  const [showModalChangeAlert, setShowModalChangeAlert] = useState<boolean>(false);
  const [showModalEditRecipients, setShowModalEditRecipients] = useState<boolean>(false);

  if (!account) return null;
  return (
    <>
      <div
        className={cn(
          'w-80 bg-white p-6 dark:bg-soft-black',
          PaletteUtils.isVcfcPalette && 'rounded-xl dark:border dark:border-gray-black',
          'max-[1440px]:w-full',
        )}
      >
        <AccountSidebarItems
          account={account}
          onShowEditModal={() => setShowModalEdit(true)}
          onShowChangeAlertModal={() => setShowModalChangeAlert(true)}
          onShowEditRecipientsModal={() => setShowModalEditRecipients(true)}
        />
      </div>
      <EditDetailsModal
        show={showModalEdit}
        onClose={() => setShowModalEdit(false)}
        account={account}
        initial={{ label: account.accountLabel ?? '', costCentre: account.costCentre ?? '', category: account.category ?? '' }}
      />
      <ChangeAlertModal
        show={showModalChangeAlert}
        onClose={() => setShowModalChangeAlert(false)}
        account={account}
        initialValue={account.minimalBalanceAlertSubscription?.minimalBalance}
        initialRecipients={account.minimalBalanceAlertSubscription?.recipientDetails}
        subId={account.minimalBalanceAlertSubscription?.subscriptionId}
      />
      <EditRecipientsModal
        isOpen={showModalEditRecipients}
        onClose={() => setShowModalEditRecipients(false)}
        accountId={account.id}
        recipients={account.declinedAuthorizationSubscription?.recipientDetails}
        subId={account.declinedAuthorizationSubscription?.subscriptionId}
      />
    </>
  );
};
